let cardSwiper = new Swiper('.card-carousel', {
    direction: 'horizontal',
    slidesPerView: 2,
    spaceBetween: 4,
    loop: false,
    scrollbar: {
        el: '.swiper-scrollbar',
    },
    breakpoints: {
        640: {
            slidesPerView: 4
        }
    }
});